import * as Sentry from '@sentry/react'
import { isNativePlatform } from '@/lib/platform'

export type ShiftClockFailureStage = 'position_denied' | 'position_timeout' | 'upload' | 'clock'

/** The tags of a `shift_clock_failed` report. No coordinates, photo key or person. */
export function shiftClockFailureTags(stage: ShiftClockFailureStage, action: 'in' | 'out', native: boolean) {
  return { stage, action, native: native ? 'true' : 'false' }
}

/**
 * EP-154: a clock that did not go through reaches nobody (a request that is
 * never sent leaves no trace on the server), so the card tells Sentry once.
 * A camera cancelled after the tap is not a failure and is never reported.
 */
export function reportShiftClockFailed(stage: ShiftClockFailureStage, action: 'in' | 'out') {
  Sentry.captureMessage('shift_clock_failed', {
    level: 'warning',
    tags: shiftClockFailureTags(stage, action, isNativePlatform()),
  })
}
